import { useEffect, useState } from "react";
import { productApi } from "../api/productApi";
import { cartApi } from "../api/cartApi";
import ProductCard from "../components/ProductCard";
import Message from "../components/Message";

export default function Shop({ onCartUpdate }) {
  const [data, setData] = useState({ items: [], page: 1, pages: 1 });
  const [filters, setFilters] = useState({ name: "", type: "" });
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    async function loadInitialPage() {
      try {
        const response = await productApi.getProducts({ page: 1 });
        setData({
          items: response.items || [],
          page: response.page || 1,
          pages: response.pages || 1,
        });
      } catch (error) {
        setNotice({ type: "error", text: error.message });
      }
    }

    loadInitialPage();
  }, []);

  async function loadPage(page, nextFilters = filters) {
    try {
      const response = await productApi.getProducts({
        page,
        name: nextFilters.name.trim(),
        type: nextFilters.type.trim(),
      });
      setData({
        items: response.items || [],
        page: response.page || 1,
        pages: response.pages || 1,
      });
    } catch (error) {
      setNotice({ type: "error", text: error.message });
    }
  }

  function handleSearch(event) {
    event.preventDefault();
    loadPage(1);
  }

  function clearSearch() {
    const emptyFilters = { name: "", type: "" };
    setFilters(emptyFilters);
    loadPage(1, emptyFilters);
  }

  async function handleAddToCart(productId) {
    try {
      await cartApi.addToCart(productId, 1);
      setNotice({ type: "success", text: "Product added to cart." });
      // Update cart count in navbar
      if (onCartUpdate) {
        const cart = await cartApi.getCart();
        const count = cart.items 
          ? cart.items.reduce((total, item) => total + item.quantity, 0)
          : 0;
        onCartUpdate(count);
      }
    } catch (error) {
      setNotice({ type: "error", text: error.message });
    }
  }

  return (
    <div className="shop-container">
      <div className="container">
        <h1 className="page-title">Our Shop</h1>
        <Message notice={notice} />
        <form onSubmit={handleSearch} className="admin-form" style={{ marginBottom: 24 }}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="device_name_search">Device Name</label>
              <input
                type="text"
                id="device_name_search"
                className="form-control"
                value={filters.name}
                onChange={(event) => setFilters({ ...filters, name: event.target.value })}
              />
            </div>
            <div className="form-group">
              <label htmlFor="device_type_search">Device Type</label>
              <input
                type="text"
                id="device_type_search"
                className="form-control"
                value={filters.type}
                onChange={(event) => setFilters({ ...filters, type: event.target.value })}
              />
            </div>
          </div>
          <button type="submit" className="btn btn-primary">Search</button>
          <button type="button" className="btn btn-secondary" onClick={clearSearch} style={{ marginLeft: 10 }}>Clear</button>
        </form>
        <div className="shop-content">
          <div className="products-grid">
            {data.items.length > 0 ? (
              data.items.map((product) => (
                <ProductCard key={product.id} product={product} onAddToCart={handleAddToCart} />
              ))
            ) : (
              <p>No devices found.</p>
            )}
          </div>
        </div>

        <div className="pagination">
          <button className="btn btn-sm" disabled={data.page <= 1} onClick={() => loadPage(data.page - 1)}>
            Previous
          </button>

          {Array.from({ length: data.pages }, (_, index) => index + 1).map((pageNum) => (
            <button
              key={pageNum}
              className={`btn btn-sm ${pageNum === data.page ? "current-page" : ""}`}
              onClick={() => loadPage(pageNum)}
            >
              {pageNum}
            </button>
          ))}

          <button className="btn btn-sm" disabled={data.page >= data.pages} onClick={() => loadPage(data.page + 1)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
